/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class UpgradeRulesApi {
    static getInstance() {
        if (!this.instance) this.instance = new UpgradeRulesApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取升级规则列表
    async getRuleList (param,num,size){
        let url = `/api/sys/upgrade-rules/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param || {},'POST')
        return result
    }

    // 获取升级规则项
    async getRuleItemList (param,num,size){
        // let url = `/api/sys/upgrade-rules/list?page_num=${num}&page_size=${size}`
        let url = `/api/sys/upgrade-item/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增升级规则
    async addRule (param){
        let url = `/api/sys/upgrade-rules`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑升级规则
    async editRule (param){
        let url = `/api/sys/upgrade-rules`
        let result = await this.getData(url,param,'PUT')
        return result
    }

    // 取消升级规则
    async cancelRule (id){
        let url = `/api/sys/upgrade-rules/${id}`
        let result = await this.getData(url,{},'PUT')
        return result
    }

    // 获取部件查询列表数据
    async getPartsList (){
        let url = `/api/sys/firmware/part/list`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取部件查询列表数据
    async getHardwareList (param){
        let url = `/api/sys/firmware/hardware/list`
        let result = await this.getData(url,param,'GET')
        return result
    }



}

export {
    UpgradeRulesApi
}